import { captureException, captureMessage } from '@sentry/react';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';

const UnblockUser = ({ user, show, setShow, getBlockedUsers }) => {
    const dispatch = useDispatch();

    const handleUnblock = async () => {
        await axios.patch('/api/blocks', {
            su: user.id
        })
            .then(response => {
                setShow(false);
                getBlockedUsers();
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'User successfully unblocked'
                }));
            })
            .catch(error => {
                captureException(error);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: `Unblocking ${user.login} failed`
                }));
            });
    };

    return <div className='unblock-user'>
        {
            show && <AlertConfirmModal
                modalBody={`Unblock ${user.login}?`}
                useFunction={handleUnblock}
                show={show}
                setShow={setShow}
                isConfirm
            />
        }
    </div>;
};

export default UnblockUser;
